export class SweetFaceMerchantDto {
  id: number;
  pieMerchantId: number;
  contactEmail?: string;
  name: string;
  currencyCode: string;
  address: string;
  vatNumber?: string;
}
